import styled, { css } from 'styled-components'

export const StyledPostcodeDiv = styled.div`
    position: relative;
    &:only-child {
        width: 100%;
    }
    label {
        font-size: 16px;
        line-height: 24px;
    }
`

export const StyledPostcodeButton = styled.button`
    ${({ theme }) => {
        return css`
            &:hover {
                color: ${theme.color.border.focus};
                svg {
                    fill: ${theme.color.border.focus};
                }
            }
            svg {
                fill: ${theme.color.icon.inputMarker.default};
            }
            &:disabled {
                color: ${theme.color.border.disabled};
            }
            align-items: center;
            background: none;
            border: none;
            bottom: 0;
            cursor: pointer;
            display: flex;
            height: 100%;
            justify-content: center;
            position: absolute;
            right: 0;
            width: 48px;
            max-height: 52px;
        `
    }}
`
